import { Component, HostBinding, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { ThemeOptions } from '../../../../theme-options';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  faEllipsisV = faEllipsisV;

  constructor(public globals: ThemeOptions) { }

  @HostBinding('class.isActive')
  get isActiveAsGetter() {
    return this.isActive;
  }

  isActive: boolean;
  isAdmin: boolean = false;

  @select('config') public config$: Observable<any>;

  ngOnInit(): void {
    // Retrieve userDetails from localStorage
    const userDetailsString = localStorage.getItem('userDetails');

    if (userDetailsString) {
      try {
        const userDetails = JSON.parse(userDetailsString);

        // Check if preferredGroups contains a group with groupId = 0
        const hasGroupZero = userDetails?.preferredGroups?.some(
          (group: any) => group.groupId === 0
        );

        if (hasGroupZero) {
          this.isAdmin = true;
        }

      } catch (error) {
        console.error('Error parsing userDetails from localStorage:', error);
      }
    }
  }

  toggleHeaderMobile() {
    this.globals.toggleHeaderMobile = !this.globals.toggleHeaderMobile;
  }

}
